module.exports = __webpack_public_path__ + "img/triangle-fill.ed694898.svg";